import React, { useEffect, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { ErrorToast, decryptAESData } from '../utils/Utils';

export const OtpTable = () => {
  const dispatch = useDispatch();
  const [otpData, setOtpData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const dealershipID = useSelector((state) => state.getDealershipID);
  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.DEALER_OTP_DETAILS.replace('DEALER_ID', dealershipID))
      .then((response) => {
        dispatch(showProgress(false));
        setOtpData(response);
      })
      .catch(() => {
        dispatch(showProgress(false));
      });
  };

  const viewOTP = async (cell) => {
    dispatch(showProgress(true));
    try {
      const rowData = cell.row.original;
      const { hash, otpType } = rowData;
      const payload = { hash, otpType };
      const res = await service.post(apiEndpoints.DEALER_OTP, payload);
      const otp = decryptAESData(res, process.env.REACT_APP_OTP_KEY);
      const updatedRowData = { ...rowData, loginOtp: otp };
      const updatedOtpData = otpData.map((item) =>
        item.hash === hash && item.otpType === otpType ? updatedRowData : item,
      );
      setOtpData(updatedOtpData);
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const columns = [
    {
      accessorKey: 'primaryContactEmail',
      header: 'Email',
      muiTableHeadCellProps: {
        sx: { color: '#A9A9A9', border: 'none', background: '#F4F4F4' },
      },
    },
    {
      accessorKey: 'loginOtp',
      header: 'Login OTP',
      muiTableHeadCellProps: {
        sx: { color: '#A9A9A9', border: 'none', background: '#F4F4F4' },
      },
      // eslint-disable-next-line react/no-unstable-nested-components, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      Cell: ({ cell }) => (
        <Grid style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '50px' }}>
          <Typography>{cell.getValue()}</Typography>
          <Typography onClick={() => viewOTP(cell)}>
            <Visibility />
          </Typography>{' '}
        </Grid>
      ),
    },
    {
      accessorKey: 'otpType',
      header: 'OTP Type',
      muiTableHeadCellProps: {
        sx: { color: '#A9A9A9', border: 'none', background: '#F4F4F4' },
      },
    },
    {
      accessorKey: 'loginOtpExpiry',
      header: 'Login OTP Expiry',
      muiTableHeadCellProps: {
        sx: { color: '#A9A9A9', border: 'none', background: '#F4F4F4' },
      },
    },
    {
      accessorKey: 'updatedAt',
      header: 'Last Updated At',
      muiTableHeadCellProps: {
        sx: { color: '#A9A9A9', border: 'none', background: '#F4F4F4' },
      },
    },
  ];

  const exactMatchFilterFn = (row, columnIds, filterValue) => {
    if (!filterValue || !filterValue.trim()) return true;
    const searchLower = filterValue.toLowerCase().trim();

    try {
      const value = row.getValue('primaryContactEmail');
      if (!value) return false;
      return value.toString().toLowerCase().includes(searchLower);
    } catch (error) {
      return false;
    }
  };

  return (
    <MaterialReactTable
      columns={columns}
      data={otpData}
      muiTableContainerProps={{ sx: { height: '68vh' } }}
      muiTableBodyCellProps={{ sx: { border: 'none' } }}
      enableColumnActions
      enablePagination
      enableSorting={false}
      enableBottomToolbar
      enableTopToolbar
      enableFullScreenToggle={false}
      muiTableBodyRowProps={{ hover: true }}
      enableStickyHeader
      enableDensityToggle={false}
      autoResetPageIndex={false}
      manualFiltering={false}
      filterFns={{
        exactMatchFilter: exactMatchFilterFn,
        fuzzy: exactMatchFilterFn,
      }}
      globalFilterFn={exactMatchFilterFn}
      state={{ globalFilter }}
      onGlobalFilterChange={(value) => {
        setGlobalFilter(value);
      }}
    />
  );
};

export default OtpTable;
